var QuadRowPackageData = require('./quadRowPackageData.js');
var lib_core = require("lib-core");

var CqfpData = function(position, angle, init) {
    QuadRowPackageData.apply(this, arguments);
};

lib_core.inherit(CqfpData, QuadRowPackageData);
lib_core.JsonParser.registerClass(CqfpData, "CqfpData");

module.exports = CqfpData;
